import {
  Box,
  Button,
  Stack,
  Typography,
  InputBase,
  styled,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import { signInWithPassword } from "../../../service";
import { Await, useNavigate } from "react-router-dom";
import { loginAction, setLoading } from "../../../redux/action";
import AuthWrapper from "../AuthWrapper";
import { useDispatch } from "react-redux";
import { TextField, Grid } from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from 'yup';
 
import email_icon from "../../../images/email_icon.png";
import lock_icon from "../../../images/lock_icon.png";
import { useState } from "react";
import { dev, local, base_url } from '../../backendurl/url'
import Axios from "axios";
export default function Login() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formdata, setFormData] = useState({
    email: "",
    password: ""
  })
 
  const [error, setError] = useState('')
  const handleChange = (e, setErrors) => {
    const { name, value } = e.target;
    console.log(e.target, name, value, 'lkkk')
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
    if (name == 'email') {
      if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(value)) {
        setErrors({ [name]: '' })
      }
    } else {
      setErrors({ [name]: '' })
    }
 
  }
 
 
 
  const login = async () => {
    console.log('kkkkkk', formdata,local)
    // Your custom submit logic goes here
    try {
      const response = await Axios.post(`${base_url}/api/token/`, formdata);
      if (response.status === 200 && response?.data?.isAdmin) {
        localStorage.setItem('token',response?.data?.access)
        const expires = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toUTCString();
        document.cookie = `token=${response?.data?.access}; expires=${expires}; path=/`;
        dispatch(loginAction(response.data));
        navigate("/", { replace: true });
      } else {
        setError("Invalid credentials")
        console.log("Invalid credentials");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
 
  const validate = () => {
    const errors = {};
 
    if (!formdata.email && formdata.password == '') {
      errors.email = 'Required';
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formdata.email)) {
      errors.email = 'Invalid email address';
    }
 
    if (!formdata.password && formdata.password == '') {
      errors.password = 'Required';
    }
 
    return errors;
  };
 
  return (
    <AuthWrapper title="Login" subtitle="Please login with your email">
      <Box sx={{ mt: 3, borderRadius: '12px' }}>
        {error != '' ? <p sx={{ color: 'red' }}>{error}</p> : ''}
        <Formik
          initialValues={formdata}
          validate={validate}
          onSubmit={login}
        >
          {({ errors, touched, setErrors }) => (
            <Form >
              <Box sx={{ mt: 3, borderRadius: 19 }}>
                <Stack direction="column" justifyContent="center">
                  <TextField
                    sx={{ mb: 2 }}
                    name="email"
                    placeholder="Email"
                    onChange={(e) => handleChange(e, setErrors)}
                    error={touched.email && errors.email}
                    helperText={touched.email && errors.email}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <img src={email_icon} alt="icon" />
                          <Typography color="#111111" sx={{ ml: 2 }}>|</Typography>
                        </InputAdornment>
                      ),
                      disableUnderline: true,
                      sx: {
                        borderRadius: "12px",
                        backgroundColor: "#0000001A",
                        border: "none",
                        outline: "none",
                      },
                    }}
                  />
                  <TextField
                    sx={{ mb: 2 }}
                    name="password"
                    placeholder=" Password"
                    type="password"
                    onChange={(e) => handleChange(e, setErrors)}
                    error={touched.password && errors.password}
                    helperText={touched.password && errors.password}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <img src={lock_icon} alt="icon" />
                          <Typography color="#111111" sx={{ ml: 2 }}>
                            |
                          </Typography>
                        </InputAdornment>
                      ),
                      disableUnderline: true,
                      sx: {
                        borderRadius: "12px",
                        backgroundColor: "#0000001A",
                        border: "none",
                        outline: "none",
                      },
                    }}
                  />
                </Stack>
                <Stack direction="row" justifyContent="end">
                  <Button href="forgotpassword" sx={{ color: "#0085FF", boxShadow: 'none' }}>
                    Forgot Password?
                  </Button>
                </Stack>
                <Button
                  type="submit"
                  variant="contained"
                  style={{ backgroundColor: "#0081F8" }}
                  sx={{ width: "350px", height: "40px", mt: 4, boxShadow: 'none' }}
                // disabled={isSubmitting}
                // onClick={login}
                >
                  Login
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
    </AuthWrapper>
  );
}